import { Injectable, inject } from '@angular/core';
import { Subject, Observable, EMPTY } from 'rxjs';
import { map, filter } from 'rxjs/operators';
import { Message } from '@stomp/stompjs';
import { RxStompService } from './rx-stomp.service';
import config from '../../auth_config.json';

export interface TimelineJournalEvent {
  event: string;              // e.g. "PROJECT_TIMELINE_MUTATED"
  project_id: string;         // e.g. "PROJ-D1A47A61"
  action: string;             // e.g. "REASSIGN_LINK", "CREATE_COMPONENT"
  triggered_by: string;       // User sub
  target_id?: string;
  timestamp?: string;
}

@Injectable({
  providedIn: 'root'
})
export class WebsocketService {
  // Original WebSocket state
  private socket!: WebSocket;
  messageReceived: Subject<string> = new Subject<string>();
  // Inject RxStompService for RabbitMQ STOMP channel subscriptions
  private readonly rxStompService = inject(RxStompService);
  constructor() { }

  connect(): void {
    var webSocketUrl = config.queueUri.replace("https", "wss");
    webSocketUrl = webSocketUrl.replace("http", "ws");
    console.log(webSocketUrl);
    this.socket = new WebSocket(`${webSocketUrl}/ws`);

    this.socket.onopen = () => {
      console.log('WebSocket connection established.');
    };

    this.socket.onmessage = (event) => {
      const message = event.data;
      console.log('Received message:', message);
      this.messageReceived.next(message);
      return true;
    };

    this.socket.onclose = (event) => {
      console.log('WebSocket connection closed:', event);
    };

    this.socket.onerror = (error) => {
      console.error('WebSocket error:', error);
    };
  }

  sendMessage(message: string): void {
    if (this.socket) {
      this.socket.send(message);
    }
  }

  closeConnection(): void {
    if (this.socket) {
      this.socket.close();
    }
  }

  // ------------------------------------------------------------------
  // 🟢 NEW: Non-destructive WebSTOMP Project Timeline Subscription
  // ------------------------------------------------------------------

  /**
   * Watches real-time project events broadcast from Python via RabbitMQ amq.topic
   */
  watchProjectEvents(projectId: string): Observable<TimelineJournalEvent> {
    if (!projectId) return EMPTY;
    // Listens on /topic/project.{projectId} 
    return this.rxStompService.watch(`/topic/project.${projectId}`).pipe(
      map((message: Message) => {
        try {
          return JSON.parse(message.body) as TimelineJournalEvent;
        } catch (e) {
          console.error('[WebsocketService] Failed to parse STOMP message frame:', e);
          return null;
        }
      }),
      filter((evt): evt is TimelineJournalEvent => evt !== null)
    );
  }
}